import { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

type Props = { label: string; description: string; onReset: () => Promise<void>; disabled?: boolean };

const AdminResetControl = ({ label, description, onReset, disabled }: Props) => {
  const [visible, setVisible] = useState(false);
  const [confirmation, setConfirmation] = useState("");
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (confirmation !== "RESET") return;
    setSaving(true);
    try { await onReset(); setVisible(false); setConfirmation(""); } finally { setSaving(false); }
  };
  return <>
    <div className="flex justify-content-center mt-5 mb-2"><Button type="button" label={label} icon="pi pi-trash" severity="danger" outlined disabled={disabled} onClick={() => setVisible(true)} /></div>
    <Dialog visible={visible} modal header={label} style={{ width: "34rem", maxWidth: "94vw" }} onHide={() => !saving && setVisible(false)}>
      <div className="flex flex-column gap-3">
        <div className="text-color-secondary">{description}</div>
        <div className="p-message p-message-error p-3">This action is permanent and cannot be undone.</div>
        <label htmlFor="admin-reset-confirmation">Type <strong>RESET</strong> to continue</label>
        <InputText id="admin-reset-confirmation" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} autoComplete="off" />
        <div className="flex justify-content-end gap-2"><Button type="button" label="Cancel" text onClick={() => setVisible(false)} disabled={saving} /><Button type="button" label="Reset permanently" icon="pi pi-trash" severity="danger" onClick={() => void submit()} disabled={saving || confirmation !== "RESET"} loading={saving} /></div>
      </div>
    </Dialog>
  </>;
};
export default AdminResetControl;
